import {
  Box,
  Flex,
  Text,
  Table,
  Thead,
  Tbody,
  Tr,
} from '@chakra-ui/react';
import { Controller } from 'react-hook-form';

import { IField } from '../../../interfaces/IField';
import { DefinedValidations } from '../../../interfaces/Validations';
import useValidate from '../../../hooks/useValidate';
import TableHeader from '../TableHeader';
import AmslerChecklistTableRow from './AmslerChecklistTableRow';

interface IAmslerChecklistTable extends IField {
  data?: any;
  description?: string;
  variant?: string;
  help?: string;
  styles?: {

    font?: string
  };
}

interface IDataValues {
  checkNumber: string;
  description: string;
  projectLeader: string;
  technican: string;
}

const definedValidations: DefinedValidations = {
  notEmpty: (label, validationValue, value) => {
    if (validationValue && !value) {
      return `Cannot be empty`;
    }
  },
};

const AmslerChecklistTable = ({ control, name, label, description, data, validations = {}, disabled = false, help = '', required, styles }: IAmslerChecklistTable) => {
  const validate = useValidate(label || name, validations || {}, definedValidations);

  return (
    <Controller
      name={name}
      control={control}
      rules={{ validate }}
      render={({ field, fieldState }) => {
        const { onChange, value: fieldValue } = field;
        const { error } = fieldState;
        // Use form value as single source of truth to avoid losing edits when form resets
        // or when switching tabs (no local state sync that could overwrite with stale data)
        const dataValues: IDataValues[] = (fieldValue && Array.isArray(fieldValue) && fieldValue.length > 0)
          ? fieldValue
          : (data ? JSON.parse(JSON.stringify(data)) : []);

        const updatePeopleValue = (value, index, type) => {
          const current = fieldValue && Array.isArray(fieldValue) ? fieldValue : (data ? JSON.parse(JSON.stringify(data)) : []);
          const updatedData = JSON.parse(JSON.stringify(current));
          if (updatedData[index]) {
            updatedData[index][type] = value;
            onChange(updatedData);
          }
        }

        return (
          <Box w='full' id={name} mt='none' maxW='980px'>
            {label && (
              <Flex pt='15px' pb={1} align='center' justify='space-between' mb='none'>
                <Box
                  color={error ? 'textInput.labelFont.error' : styles ? styles?.font : 'textInput.labelFont.normal'}
                  fontWeight='bold'
                  fontSize='md'
                  position='static'
                  left='none'
                  zIndex={2}
                >
                  {label}
                  <Text
                    pt='5px'
                    color='textInput.labelFont.normal'
                    fontWeight='semi_medium'
                    fontSize='smm'
                  >{description}</Text>
                </Box>
              </Flex>
            )}
            <Table fontSize='smm'>
              <Thead>
                <Tr>
                  <TableHeader header='Check No.' styles={{}}></TableHeader>
                  <TableHeader header='Description' styles={{}}></TableHeader>
                  <TableHeader header='Project Lead' styles={{ paddingInline: "20px" }}></TableHeader>
                  <TableHeader header='Technician' styles={{ paddingInline: "20px" }}></TableHeader>
                </Tr>
              </Thead>
              <Tbody left='-10px'>
                {dataValues?.map((row, index) =>
                  <AmslerChecklistTableRow
                    name={name}
                    key={row?.checkNumber ?? index}
                    indexValue={index}
                    index={row?.checkNumber}
                    description={row?.description}
                    disabled={disabled}
                    control={control}
                    updatePeopleValue={updatePeopleValue}
                  />)
                }
              </Tbody>
            </Table>
            {error && <Box fontSize='ssm' ml={1} color='textInput.error'>{error.message}</Box>}
          </Box >
        );
      }}
    />
  );
};

export default AmslerChecklistTable;

export const amslerChecklistTableStyles = {
  signatureTable: {

  }
};
